const cartDrawer = document.querySelector('.header-action-item.header-cart.position-relative');

if (cartDrawer) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes') {
        if (cartDrawer.classList.contains('active')) {
          BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
           BSS_B2B.observer.cartSubject.listenCartCheckout()
           BSS_B2B.dc.initFunction()
        }
      }
    }
  });

  observer.observe(cartDrawer, { attributes: true });
}


document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`[action="/search"] input[name="q"]`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
  const btnCheckoutList = document.querySelectorAll('button[name="checkout"]');
      btnCheckoutList.forEach((btnCheckout) => {
          btnCheckout.addEventListener("click", () => {
          btnCheckout.disabled = true;
          btnCheckout.style.setProperty("pointer-events", "none", "important");
      });
  });
});
